import Modal from "@/components/Common/Modal";
import useAdditionalLimitRequest from "@/hooks/useAdditionalLimitRequest";
import RequestMoreContent from "@/pages/plans/RequestMoreContent";
import {isRequestMoreResourcesModalOpenAtom} from "@/store/jotaiAtoms";
import useUserStore from "@/store/user";
import {useAtom} from "jotai";
import {RESET} from "jotai/utils";
import {FC} from "react";
import {useTranslation} from "react-i18next";

const RequestMoreModal: FC = () => {
  const {t} = useTranslation("payments");
  const [requestModal, setRequestModal] = useAtom(isRequestMoreResourcesModalOpenAtom);
  const subBrandId = useUserStore(state => state.user.sub_brands?.at(0)?.company.id);
  const {isPending, request} = useAdditionalLimitRequest({companyId: subBrandId!, type: requestModal.type});

  return (
    <Modal
      onClose={() => setRequestModal(RESET)}
      shouldCloseOnConfirm
      onConfirm={request}
      isLoading={isPending}
      backgroundClassName="flex max-w-200"
      modalTitle={t("request_more", {type: requestModal.type})}>
      <RequestMoreContent type={requestModal.type} />
    </Modal>
  );
};

export default RequestMoreModal;
